/* MINDS card swatches — vanilla JS, no jQuery, no defer tricks.
   Behavior:
   - Hover (mouseenter) or tap/click a color circle on a collection card
     -> the card's main (primary) image swaps to that variant's photo.
   - Leaving the swatch row restores the original image.
   - While a swatch is active, the theme's hover second-image is suppressed
     via the .cs-swatches-on class on the card cell (see card-swatches.css).
   Loaded from layout/theme.liquid after js_main.js. Remove that one
   script include line to fully disable. */
(function () {
  'use strict';

  function cellOf(row) {
    return row.closest('.site-box-content') || row.parentElement;
  }

  function primaryImgOf(row) {
    var cell = cellOf(row);
    if (!cell) return null;
    return cell.querySelector('.product-item .box--product-image.primary img');
  }

  function stash(img) {
    if (img.dataset.csStashed) return;
    img.dataset.csStashed = '1';
    img.dataset.csSrc = img.getAttribute('src') || '';
    img.dataset.csSrcset = img.getAttribute('srcset') || '';
    img.dataset.csDataSrcset = img.getAttribute('data-srcset') || '';
  }

  function activate(btn) {
    var row = btn.closest('.cs-swatch-row');
    if (!row) return;
    var img = primaryImgOf(row);
    var cell = cellOf(row);
    var full = btn.getAttribute('data-full');
    if (img && full) {
      stash(img);
      img.setAttribute('src', full);
      var ss = btn.getAttribute('data-srcset');
      if (ss) {
        img.setAttribute('srcset', ss);
      } else {
        img.removeAttribute('srcset');
      }
      img.removeAttribute('data-srcset');
      if (!img.classList.contains('lazyloaded')) img.classList.add('lazyloaded');
    }
    if (cell) cell.classList.add('cs-swatches-on');
    var all = row.querySelectorAll('.cs-swatch');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active');
    btn.classList.add('is-active');
  }

  function deactivate(row) {
    if (!row) return;
    var img = primaryImgOf(row);
    var cell = cellOf(row);
    if (img && img.dataset.csStashed) {
      if (img.dataset.csSrc) img.setAttribute('src', img.dataset.csSrc);
      if (img.dataset.csSrcset) {
        img.setAttribute('srcset', img.dataset.csSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      if (img.dataset.csDataSrcset) {
        img.setAttribute('data-srcset', img.dataset.csDataSrcset);
      }
    }
    if (cell) cell.classList.remove('cs-swatches-on');
    var all = row.querySelectorAll('.cs-swatch');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active');
    row.removeAttribute('data-cs-pinned');
  }

  function inRow(el, row) {
    return el && row && (el === row || row.contains(el));
  }

  document.addEventListener('mouseover', function (e) {
    var btn = e.target.closest ? e.target.closest('.cs-swatch') : null;
    if (btn) activate(btn);
  });

  document.addEventListener('mouseout', function (e) {
    var row = e.target.closest ? e.target.closest('.cs-swatch-row') : null;
    if (!row) return;
    if (inRow(e.relatedTarget, row)) return;
    if (row.hasAttribute('data-cs-pinned')) return;
    deactivate(row);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.cs-swatch') : null;
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('.cs-swatch-row');
    if (row) row.setAttribute('data-cs-pinned', '1');
    activate(btn);
  });

  document.addEventListener('focusin', function (e) {
    var btn = e.target.closest ? e.target.closest('.cs-swatch') : null;
    if (btn) activate(btn);
  });

  document.addEventListener('focusout', function (e) {
    var row = e.target.closest ? e.target.closest('.cs-swatch-row') : null;
    if (!row) return;
    if (inRow(e.relatedTarget, row)) return;
    if (row.hasAttribute('data-cs-pinned')) return;
    deactivate(row);
  });
})();
